export const STUDENT_NOTIF_READ_EVENT = "ems-student-notif-read";

export function studentReadNotifStorageKey(orgId, studentId) {
  return `ems_student_read_notifs:${orgId || ""}:${studentId || ""}`;
}

export function studentNotificationId(notification) {
  if (notification?.id) return String(notification.id);
  return [
    notification?.type,
    notification?.title,
    notification?.text,
    notification?.at,
    notification?.sort_time,
  ]
    .filter((part) => part != null && String(part).trim() !== "")
    .join("|");
}

export function studentNotificationFallbackId(notification) {
  return [
    notification?.type,
    notification?.title,
    notification?.text,
    notification?.at,
  ]
    .filter((part) => part != null && String(part).trim() !== "")
    .join("|");
}

export function loadStudentReadNotifIds(orgId, studentId) {
  try {
    const raw = localStorage.getItem(studentReadNotifStorageKey(orgId, studentId));
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

export function markStudentNotificationRead(orgId, studentId, notification) {
  if (!notification) return;
  const primary = studentNotificationId(notification);
  const fallback = studentNotificationFallbackId(notification);
  if (!primary && !fallback) return;
  const ids = loadStudentReadNotifIds(orgId, studentId);
  const next = [...ids];
  [primary, fallback].forEach((id) => {
    if (id && !next.includes(id)) next.push(id);
  });
  if (next.length === ids.length) return;
  try {
    localStorage.setItem(
      studentReadNotifStorageKey(orgId, studentId),
      JSON.stringify(next)
    );
  } catch {
    // Ignore storage failures.
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(STUDENT_NOTIF_READ_EVENT, {
        detail: { id: primary || fallback, orgId, studentId },
      })
    );
  }
}

export function isStudentNotificationRead(notification, orgId, studentId) {
  const read = new Set(loadStudentReadNotifIds(orgId, studentId));
  const primary = studentNotificationId(notification);
  const fallback = studentNotificationFallbackId(notification);
  return (primary && read.has(primary)) || (fallback && read.has(fallback));
}

export function filterUnreadStudentNotifications(rows, orgId, studentId) {
  return (Array.isArray(rows) ? rows : []).filter(
    (n) => !isStudentNotificationRead(n, orgId, studentId)
  );
}
